



































import { Feed } from '@empathybroker/tsclient-index/dist/models/feed';

import { mapGetters } from 'vuex';

import { INDEX_CONSTS } from '../../store/index/index.consts';

import { UiButton, UiFileupload, UiSelect } from '../keen-ui';

export default {
  name: 'index-submit-form',
  components: {
    UiButton,
    UiFileupload,
    UiSelect
  },
  computed: {
    ...mapGetters(INDEX_CONSTS.moduleName, {
      info: INDEX_CONSTS.getters.info
    }),
    clientFeedIdsOptions: function (): string[] {
      if (!!this.info.feeds) {
        return this.info.feeds.reduce((feedIdsOptions: string[], feed: Feed) => {
          if (!this.feedIdsToExclude.includes(feed.id)) {
            feedIdsOptions.push(feed.id);
          }
          return feedIdsOptions;
        }, []);
      }
      return [];
    }
  },
  data: function () {
    return {
      feedIdsToExclude: [
        'boosts',
        'boosts-delta',
        'links',
        'links-delta',
        'synonymize',
        'topclicked',
        'toptrend',
        'querysignals',
        'imaginize'
      ],
      job: {
        formData: new FormData(),
        clientFeedId: ''
      },
      messages: this.$epb.messages.tools.index
    };
  },
  methods: {
    resetForm: function (): void {
      this.job = {
        formData: new FormData(),
        clientFeedId: ''
      };
      this.$refs.feedFile.hasSelection = false;
      this.$refs.feedFile.$forceUpdate();
    }
  }
};
